<div class="form-group align-self-end {{ settings.class }}" *ngIf="settings">
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
  </label>
  <div>
    <div
      [ngClass]="
        (settings.type === 'radio-horizontal'
          ? 'checkbox-radio-container direction-horizontal'
          : 'checkbox-radio-container') +
        ' ' +
        (settings.customInputClass ? settings.customInputClass : '')
      "
    >
      <ng-container *ngFor="let option of options; let optionIndex = index">
        <div
          class="form-check"
          *ngIf="!option.hide"
          (click)="onValueChange(option)"
        >
          <input
            class="form-check-input"
            type="radio"
            name="{{ settings.fieldName }}-radiobtn{{ option.id }}"
            id="{{ settings.fieldName }}-radiobtn{{ option.id }}-{{
              optionIndex
            }}"
            value="{{ option.id }}"
            [checked]="data && option.id === data.id"
          />
          <label
            class="form-check-label"
            [ngStyle]="option.style"
            for="{{ settings.fieldName }}f-radiobtn{{ option.id }}-{{
              optionIndex
            }}"
          >
            {{ option.value }}
          </label>
        </div>
      </ng-container>
    </div>
  </div>
</div>
